import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseTableReport from 'components/atoms/base-table/report/report';
import { useGetNewPatientsReport } from 'infrastructure/hooks/rpm/newPatientsReport/use-get-new-patients-report';

import { newPatientsReportTableColumns } from './cols';

import type { INewPatientsReportListFilters } from 'infrastructure/interfaces';

interface IProps {
  filters: INewPatientsReportListFilters;
  updateFilter: (newFilter: Partial<INewPatientsReportListFilters>) => void;
}

const ActivityReportTable: React.FC<IProps> = ({ filters, updateFilter }) => {
  const { t } = useTranslation();

  const { reports, loading, meta } = useGetNewPatientsReport({ meta: filters });
  const columns = newPatientsReportTableColumns(filters.page ?? 1);

  const onChangePage = (page: number) => {
    updateFilter({ page });
  };

  return (
    <div>
      <BaseTableReport
        isLoading={loading}
        columns={columns}
        headerTitle={t('labels.patients')}
        dataSource={reports}
        pagination={{
          current: meta.page ?? 0,
          pageSize: meta.items,
          total: meta?.totalCount ?? 0,
          onChange: onChangePage,
        }}
        showCount
        anchor
        rowClassName="activity-row"
      />
    </div>
  );
};

export default ActivityReportTable;
